// utils/complianceApi.js
// ──────────────────────────────────────────────────────────────────────────────
// API helpers for Mandatory Training campaigns + Employee Groups.
// ──────────────────────────────────────────────────────────────────────────────

import apiClient from './apiClient';

const MT = '/mandatory-training';
const EG = '/employee-groups';

// ── Mandatory Training (admin) ──────────────────────────────────────────────
export const listCampaigns = (params = {}) =>
  apiClient.get(MT, { params });

export const getCampaign = (id) =>
  apiClient.get(`${MT}/${id}`);

export const createCampaign = (body) =>
  apiClient.post(MT, body);

export const updateCampaign = (id, body) =>
  apiClient.put(`${MT}/${id}`, body);

export const activateCampaign = (id) =>
  apiClient.post(`${MT}/${id}/activate`);

export const archiveCampaign = (id) =>
  apiClient.post(`${MT}/${id}/archive`);

export const deleteCampaign = (id) =>
  apiClient.delete(`${MT}/${id}`);

export const previewAudience = (audience) =>
  apiClient.post(`${MT}/preview-audience`, { audience });

export const getCampaignReport = (id) =>
  apiClient.get(`${MT}/${id}/report`);

export const exemptAssignment = (assignmentId, reason) =>
  apiClient.post(`${MT}/assignments/${assignmentId}/exempt`, { reason });

export const downloadCampaignPdf = (id) =>
  apiClient.get(`${MT}/${id}/report.pdf`, { responseType: 'blob' });

export const downloadCampaignCsv = (id) =>
  apiClient.get(`${MT}/${id}/report.csv`, { responseType: 'blob' });

// ── Mandatory Training (student) ────────────────────────────────────────────
export const getMyMandatoryAssignments = () =>
  apiClient.get(`${MT}/me`);

// ── Employee Groups (admin) ─────────────────────────────────────────────────
export const listGroups = () =>
  apiClient.get(EG);

export const getGroup = (id) =>
  apiClient.get(`${EG}/${id}`);

export const createGroup = (body) =>
  apiClient.post(EG, body);

export const updateGroup = (id, body) =>
  apiClient.put(`${EG}/${id}`, body);

export const deleteGroup = (id) =>
  apiClient.delete(`${EG}/${id}`);
